import React, { createContext, useState, ReactNode } from 'react';

interface PaymentContextProps {
  wallet: string;
  setWallet: (wallet: string) => void;
  amount: string;
  setAmount: (amount: string) => void;
  paymentIdUrl: string;
  setPaymentIdUrl: (paymentIdUrl: string) => void;
  timeout: number;
  setTimeout: (timeout: number) => void;
}

interface PaymentProviderProps {
  children: ReactNode;
}

export const PaymentContext = createContext<PaymentContextProps>({
  wallet: '',
  setWallet: () => {},
  amount: '',
  setAmount: () => {},
  paymentIdUrl: '',
  setPaymentIdUrl: () => {},
  timeout: 1200000,
  setTimeout: () => {},
});

export const PaymentProvider = ({ children }: PaymentProviderProps) => {
  const [wallet, setWallet] = useState('');
  const [amount, setAmount] = useState('');
  const [paymentIdUrl, setPaymentIdUrl] = useState('');
  const [timeout, setTimeout] = useState(1200000);

  return (
    <PaymentContext.Provider
      value={{
        wallet,
        setWallet,
        amount,
        setAmount,
        paymentIdUrl,
        setPaymentIdUrl,
        timeout,
        setTimeout,
      }}
    >
      {children}
    </PaymentContext.Provider>
  );
};
